export default __webpack_public_path__ + "static/media/instagram.6671d916.svg";